// removed by extract-text-webpack-plugin
module.exports = {"map":"flight-map__map___2ia8k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/flight-map/flight-map.scss
// module id = 627
// module chunks = 0